import { getRequest, sendRequest } from './api';

/**
 * Получение клиентов в лк.
 * Обязательно быть владельцем компании
 * @param {organisation_id} 
 * @returns {Promise<any>} - Ответ от сервера.
 */
export async function fetchClients(organisation_id) {
  return getRequest('/user/client', { organisation_id });
}

/**
 * Создание нового клиента в системе.
 *
 * @param {Object} clientData - Данные клиента.
 * @param {number} clientData.type_id - Тип клиента (по умолчанию 1).
 * @param {string} clientData.organisation_id - ID организации.
 * @param {string} clientData.email - Email клиента.
 * @param {string} clientData.external_id - Внешний идентификатор клиента.
 * @param {string} clientData.first_name - Имя клиента.
 * @param {string} clientData.last_name - Фамилия клиента.
 * @param {string} clientData.patronymic - Отчество клиента.
 * @param {string} clientData.nickname - Никнейм клиента.
 * @param {string} clientData.login - Логин клиента.
 * @param {string} clientData.password - Пароль клиента.
 * @param {string} clientData.phone - Телефон клиента.
 * @returns {Promise<Object>} - Ответ сервера с созданным клиентом.
 */
export async function createClient(clientData) {
  return sendRequest('/user', 'POST', clientData);
}
